import type { ConfigServerOverview } from "@/api/config-server-stages";
import type { ExecutionStatus } from "@/hooks/useAgentExecution";

// Ordem do grafo do agente: estrutura organizacional, SSCUI, App Fiori.
export const DOMAIN_NODES = [
  { id: "org", label: "Organizational structure" },
  { id: "sscui", label: "SSCUI configurations" },
  { id: "fiori", label: "App Fiori configurations" },
] as const;
type DomainNodeId = (typeof DOMAIN_NODES)[number]["id"];
type DomainNodeStatus = "complete" | "running" | "queued" | "error";

/** O status local vence o retrato anterior; active_run retoma o progresso após F5. */
export function domainNodeStates(
  overview: ConfigServerOverview | undefined,
  executionStatus: ExecutionStatus,
): Record<DomainNodeId, DomainNodeStatus> {
  const extraction = overview?.stages.extraction;
  const active = overview?.active_run?.kind === "extraction";
  const failed = executionStatus === "failed";
  const running = !failed && executionStatus !== "completed" && (active || executionStatus === "running");
  const snapshotCount = Math.max(0, Math.min(3, extraction?.domains_done ?? 0));
  let done = snapshotCount;
  if (executionStatus === "completed") {
    done = DOMAIN_NODES.length;
  } else if ((failed && extraction?.state === "done") || (executionStatus === "running" && !active)) {
    done = 0;
  } else if (extraction?.state === "done" && !running) {
    done = DOMAIN_NODES.length;
  }
  // Se os três fetches terminaram e a publicação falhou, o último nó mostra o erro.
  const errorIndex = Math.min(done, DOMAIN_NODES.length - 1);
  const states: Record<DomainNodeId, DomainNodeStatus> = { org: "queued", sscui: "queued", fiori: "queued" };
  DOMAIN_NODES.forEach((node, index) => {
    if (failed) {
      if (index < errorIndex) states[node.id] = "complete";
      else if (index === errorIndex) states[node.id] = "error";
    } else if (index < done) {
      states[node.id] = "complete";
    } else if (running && index === done) {
      states[node.id] = "running";
    }
  });
  return states;
}
